import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button, Drawer, Select } from "@mantine/core";
import React, { useState, useEffect } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Input,
    Space,
    Card, message, Descriptions, Divider,
} from "antd";
import dayjs from "dayjs";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import { Get_All_Users, Get_All_Users_Ledgers, get_dist_and_retailers, Get_User_Details, Get_user_ledger, get_users_ledger } from "../../../apicall";
const { Search } = Input;
const { RangePicker } = DatePicker;




const Usersledger = ({ Headername }) => {
    const today = dayjs();
    const [dateRange, setDateRange] = useState([
        today.startOf("day"),
        today.endOf("day"),
    ]);
    const { user } = Userauthcontexthooks();
    const [ledgerloading, setledgerloading] = useState(true);
    const [allLedgerReq, setallLedgerReq] = useState([]);
    const [transactionType, setTransactionType] = useState("ALL");
    const [status, setStatus] = useState("ALL"); // CREDIT / DEBIT
    const [searchTxn, setSearchTxn] = useState("");
    const [ledgerReq, setLedgerreq] = useState([]);
    const [ledgerDrawer, setLedgerDrawer] = useState(false);
    const [selectedLedger, setSelectedLedger] = useState(null);
    const [whichuserLedger, setwhichUserledger] = useState({
        userType: "",
        selectedUser: null,
    });
    const [userprofileLoading, setUserprofileLoading] = useState(true); // self profile
   // const [selfProfiledetails, setProfiledetails] = useState(''); // Self profile 
    const [userfindloading, setUserloading] = useState(false);
    const [mappedUsers, setMappedUsers] = useState({
        retailerLists: [],
        distributorsLists: [],
        masterDistributorLists: []
    });
    const fetchuserledger = async () => { // self ledger

        try {
            const data = await Get_All_Users_Ledgers(
                dateRange[0].format("YYYY-MM-DD"),
                dateRange[1].format("YYYY-MM-DD")
            );

            if (data.success) {
                // console.log(data);
                setallLedgerReq(data?.userLedger);
                setLedgerreq(data?.userLedger);
            }
        } catch (error) {

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setledgerloading(false);
        }

    }
    const handleSearch = () => {

        let filtered = [...allLedgerReq];

        // Transaction Type
        if (transactionType !== "ALL") {
            filtered = filtered.filter(
                item => item.transactionType === transactionType
            );
        }

        // Credit / Debit
        if (status !== "ALL") {
            filtered = filtered.filter(
                item => item.entryType === status
            );
        }

        // TXN ID Search
        if (searchTxn.trim()) {
            filtered = filtered.filter(item =>
                item.transactionId
                    .toLowerCase()
                    .includes(searchTxn.toLowerCase())
            );
        }

        setLedgerreq(filtered);
    };

    const handleReset = () => {

        setTransactionType("ALL");
        setStatus("ALL");
        setSearchTxn("");
        fetchuserledger(); // back to  self ledger
        setwhichUserledger({
            userType: "Self Ledger",
            selectedUser: null,
        })
        //setLedgerreq(allLedgerReq);
    };


    const columns = [
        {
            title: "S.No.",
            width: 55,
            render: (_, __, index) => index + 1,
        },

        {
            title: "Txn ID",
            dataIndex: "transactionId",
            width: 150,
            render: (id) => <Text copyable>{id}</Text>,
        },

        {
            title: "Type",
            dataIndex: "transactionType",
            width: 120,
            render: (type) => (
                <Tag color="blue">
                    {type.replaceAll("_", " ")}
                </Tag>
            ),
        },

        {
            title: "Credit",
            width: 120,
            fixed: "center",
            render: (_, record) =>
                record.entryType === "CREDIT" ? (
                    <Text strong style={{ color: "#52c41a" }}>
                        + ₹ {record.amount.toLocaleString()}
                    </Text>
                ) : (
                    "-"
                ),
        },

        {
            title: "Debit",
            width: 120,
            fixed: "center",
            render: (_, record) =>
                record.entryType === "DEBIT" ? (
                    <Text strong style={{ color: "#ff4d4f" }}>
                        - ₹ {record.amount.toLocaleString()}
                    </Text>
                ) : (
                    "-"
                ),
        },

        {
            title: "Balance",
            dataIndex: "closingBalance",
            width: 120,
            fixed: "center",
            render: (bal) => (
                <Text strong>
                    ₹ {bal.toLocaleString()}
                </Text>
            ),
        },

        {
            title: "Status",
            dataIndex: "status",
            width: 90,
            render: (status) => {
                let color = "default";

                if (status === "SUCCESS") color = "green";
                if (status === "FAILED") color = "red";
                if (status === "PENDING") color = "orange";
                if (status === "REVERSED") color = "purple";

                return <Tag color={color}>{status}</Tag>;
            },
        },

        {
            title: "Date & Time",
            dataIndex: "createdAt",
            width: 180,
            render: (date) =>
                dayjs(date).format("DD MMM YYYY hh:mm A"),
        },

        {
            title: "Remarks",
            dataIndex: "manualRemarks",
            width: 220,
            // ellipsis: true,
            render: (_, record) =>
                record.manualRemarks || record.autoRemarks,
        },

        {
            title: "Action",
            width: 100,
            fixed: "center",
            render: (_, record) => (
                <Button
                    // type="link"
                    variant="outline"
                    size="xs"
                    onClick={() => {
                        setSelectedLedger(record);
                        setLedgerDrawer(true);
                    }}
                >
                    View
                </Button>
            ),
        },
    ];

    const retailerOptions = mappedUsers?.retailerLists?.map((item) => ({
        value: item._id,
        label: `${item.userName} (${item.userCode})`,
    })) || [];

    const distributorOptions = mappedUsers?.distributorsLists?.map((item) => ({
        value: item._id,
        label: `${item.userName} (${item.userCode})`,
    })) || [];

    const masterDistributorOptions = mappedUsers?.masterDistributorLists?.map((item) => ({
        value: item._id,
        label: `${item.userName} (${item.userCode})`,
    })) || [];

    // const selectedUser = whichuserLedger?.userType === "Retailer"
    //     ? mappedUsers?.retailerLists?.find(
    //         (x) => x?._id === whichuserLedger?.selectedUser
    //     )
    //     : whichuserLedger?.userType === "Distributor" ? mappedUsers?.distributorsLists?.find(
    //         (x) => x?._id === whichuserLedger?.selectedUser
    //     ) : mappedUsers?.masterDistributorLists?.find(
    //         (x) => x?._id === whichuserLedger?.selectedUser)


    const handlefetchuserLedgerdetails = async (field, value) => { // onchange + fetch users ledgers data according select user

        setwhichUserledger(prev => ({
            ...prev,
            [field]: value,
        }));

        const reqID = value;
        try {
            //console.log("Request id in try block", reqID);

            setledgerloading(true);

            const data = await Get_All_Users_Ledgers(
                dateRange[0].format("YYYY-MM-DD"),
                dateRange[1].format("YYYY-MM-DD"),
                reqID
            );

            if (data.success) {
                setallLedgerReq(data.userLedger);
                setLedgerreq(data.userLedger);
            }

        } catch (error) {

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setledgerloading(false);
        }
    };

    const handleUserTypeChange = async (value) => { // onchange + fetch inside user according to user type
        setwhichUserledger((prev) => ({
            ...prev,
            userType: value,
            selectedUser: null,
        }));
        try {
            setUserloading(true);
            const data = await Get_All_Users();
            if (data.success) {
                // console.log(data);
                setMappedUsers({
                    retailerLists: data?.retailerLists,
                    distributorsLists: data?.distributorsLists,
                    masterDistributorLists: data?.masterDistributorLists,
                })
                //setWalletTransferHistory(data.transferHistory);
                //setFilteredWalletTransferHistory(data.transferHistory);
            }

        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setUserloading(false);
        }
    };

    useEffect(() => {
        const GetUserprofile = async () => {
            try {
                const data = await Get_User_Details();
                if (data.success) {
                    //console.log(data);
                    //setProfiledetails(data?.user)
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setUserprofileLoading(false);
                setledgerloading(false);
            }
        }
        // const fetchuserledger = async () => {

        //     try {
        //         const data = await Get_All_Users_Ledgers( // self ledger
        //             dateRange[0].format("YYYY-MM-DD"),
        //             dateRange[1].format("YYYY-MM-DD")
        //         );

        //         if (data.success) {
        //             //console.log(data);
        //             setallLedgerReq(data?.userLedger);
        //             setLedgerreq(data?.userLedger);
        //         }
        //     } catch (error) {

        //         message.error(
        //             error.response?.data?.message ||
        //             "Something went wrong."
        //         );
        //     } finally {
        //         setledgerloading(false);
        //     }

        // }
        if (user) {
            // fetchuserledger();
            GetUserprofile();
        }

    }, [user, dateRange]);
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Ledger</Title>
                <Text size="xs">Verify your entry in ledger</Text>
            </Container>

            <Container size={'lg'} mt={'lg'}>
                <Card title="Ledger History" style={{
                    width: "100%",
                }}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                        <Col xs={24} md={8}>
                            <RangePicker
                                style={{ width: "100%" }}
                                value={dateRange}
                                onChange={(value) => setDateRange(value)}
                                allowClear={false}
                            />
                        </Col>
                        <Col xs={24} md={4}>
                            <Select
                                placeholder="Select Ledger"
                                data={['Retailer', 'Distributor', 'Master Distributor']}
                                value={whichuserLedger.userType}
                                onChange={handleUserTypeChange}
                                loading={userprofileLoading}
                            // style={{ width: "100%" }}
                            />
                        </Col>
                        {whichuserLedger?.userType === "Retailer" && (
                            <Select
                                // label="Select Retailer"
                                placeholder="Choose Retailer"
                                searchable
                                clearable
                                nothingFoundMessage="No retailer found"
                                // withAsterisk
                                // mt="xs"
                                data={retailerOptions}
                                value={whichuserLedger.selectedUser}
                                onChange={(value) =>
                                    handlefetchuserLedgerdetails("selectedUser", value)
                                }
                                comboboxProps={{
                                    withinPortal: false,
                                }}
                                loading={userfindloading}
                            />
                        )}
                        {whichuserLedger?.userType === "Distributor" && (
                            <Select
                                // label="Select Distributor"
                                placeholder="Choose Distributor"
                                searchable
                                clearable
                                nothingFoundMessage="No distributor found"
                                // withAsterisk
                                // mt="xs"
                                data={distributorOptions}
                                value={whichuserLedger.selectedUser}
                                onChange={(value) =>
                                    handlefetchuserLedgerdetails("selectedUser", value)
                                }
                                comboboxProps={{
                                    withinPortal: false,
                                }}
                                loading={userfindloading}
                            />
                        )}
                        {whichuserLedger?.userType === "Master Distributor" && (
                            <Select
                                // label="Select Master Distributor"
                                placeholder="Choose Master Distributor"
                                searchable
                                clearable
                                nothingFoundMessage="No master distributor found"
                                // withAsterisk
                                // mt="xs"
                                data={masterDistributorOptions}
                                value={whichuserLedger.selectedUser}
                                onChange={(value) =>
                                    handlefetchuserLedgerdetails("selectedUser", value)
                                }
                                comboboxProps={{
                                    withinPortal: false,
                                }}
                                loading={userfindloading}
                            />
                        )}
                        <Col xs={24} md={4}>
                            <Select
                                value={transactionType}
                                onChange={setTransactionType}
                                data={[
                                    { label: "ALL", value: "ALL" },
                                    { label: "TOP IN", value: "TOPIN" },
                                    { label: "SELF TOP IN", value: "SELF_TOPIN" },
                                    { label: "WALLET TO WALLET", value: "WALLET_TO_WALLET" },
                                    { label: "PAYOUT", value: "PAYOUT" },
                                    { label: "REFUND", value: "REFUND" },
                                    { label: "REVERT", value: "REVERT" },
                                ]}
                            />
                        </Col>
                        <Col xs={24} md={4}>
                            <Select
                                value={status}
                                onChange={setStatus}
                                // style={{ width: "100%" }}
                                data={[
                                    { label: "ALL", value: "ALL" },
                                    { label: "CREDIT", value: "CREDIT" },
                                    { label: "DEBIT", value: "DEBIT" },
                                ]}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Search
                                placeholder="Search TXN ID"
                                allowClear
                                value={searchTxn}
                                onChange={(e) => setSearchTxn(e.target.value)}
                                onSearch={handleSearch}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={handleSearch}
                                >
                                    Search
                                </Button>

                                <Button
                                    onClick={handleReset}
                                    variant="light"
                                >
                                    Reset
                                </Button>
                                <Button type="secondary" variant="outline">
                                    Download
                                </Button>
                                <Button type="secondary" variant="outline" onClick={fetchuserledger}>
                                    Refresh
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <Table
                            columns={columns}
                            dataSource={ledgerReq}
                            loading={ledgerloading}
                            bordered
                            size="middle"
                            rowKey="_id"
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                            }}
                        // scroll={{ x: 1200 }}
                        />
                    </div>
                </Card>
            </Container>

            <Drawer
                title="Ledger Details"
                width={700}
                opened={ledgerDrawer}
                onClose={() => setLedgerDrawer(false)}
            >
                {selectedLedger && (
                    <>
                        <Descriptions
                            bordered
                            size="small"
                            column={1}
                        >
                            <Descriptions.Item label="Transaction ID">
                                {selectedLedger.transactionId}
                            </Descriptions.Item>

                            <Descriptions.Item label="Transaction Type">
                                {selectedLedger.transactionType}
                            </Descriptions.Item>

                            <Descriptions.Item label="Status">
                                <Tag color="green">
                                    {selectedLedger.status}
                                </Tag>
                            </Descriptions.Item>

                            <Descriptions.Item label="Entry Type">
                                <Tag
                                    color={
                                        selectedLedger.entryType === "CREDIT"
                                            ? "green"
                                            : "red"
                                    }
                                >
                                    {selectedLedger.entryType}
                                </Tag>
                            </Descriptions.Item>

                            <Descriptions.Item label="Amount">
                                ₹ {selectedLedger.amount}
                            </Descriptions.Item>

                            <Descriptions.Item label="Fee">
                                ₹ {selectedLedger.fee}
                            </Descriptions.Item>

                            <Descriptions.Item label="GST">
                                ₹ {selectedLedger.gst}
                            </Descriptions.Item>

                            <Descriptions.Item label="TDS">
                                ₹ {selectedLedger.tds}
                            </Descriptions.Item>

                            <Descriptions.Item label="Net Amount">
                                ₹ {selectedLedger.netAmount}
                            </Descriptions.Item>

                            <Descriptions.Item label="Opening Balance">
                                ₹ {selectedLedger.openingBalance}
                            </Descriptions.Item>

                            <Descriptions.Item label="Closing Balance">
                                ₹ {selectedLedger.closingBalance}
                            </Descriptions.Item>

                            <Descriptions.Item label="Auto Remarks">
                                {selectedLedger.autoRemarks}
                            </Descriptions.Item>

                            <Descriptions.Item label="User Remarks">
                                {selectedLedger.manualRemarks || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Created">
                                {dayjs(selectedLedger.createdAt).format(
                                    "DD MMM YYYY hh:mm:ss A"
                                )}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Transaction Details"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="From User">
                                {selectedLedger.transactionDetails?.fromUserCode || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="To User">
                                {selectedLedger.transactionDetails?.toUserCode || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Reference">
                                {selectedLedger.transactionDetails?.referenceNumber || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Bank Reference">
                                {selectedLedger.transactionDetails?.bankReference || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="API Reference">
                                {selectedLedger.transactionDetails?.apiReference || "-"}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Additional Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            {selectedLedger.displayMetaData?.length > 0 ? (
                                selectedLedger.displayMetaData.map((item) => (
                                    <Descriptions.Item
                                        key={item._id}
                                        label={item.label}
                                    >
                                        {item.value || "-"}
                                    </Descriptions.Item>
                                ))
                            ) : (
                                <Descriptions.Item label="Info">
                                    No Additional Information
                                </Descriptions.Item>
                            )}
                        </Descriptions>
                    </>
                )}
            </Drawer>
        </>
    )
}
export default Usersledger;